import { render, staticRenderFns } from "./release_edit.vue?vue&type=template&id=514d4f8c&scoped=true"
import script from "./release_edit.vue?vue&type=script&lang=js"
export * from "./release_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514d4f8c",
  null
  
)

export default component.exports